module.exports = __webpack_public_path__ + "img/Simple-Line-Icons.eot?f19a7f6c7a0b54b748277c40d7cf8882";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/simple-line-icons/fonts/Simple-Line-Icons.eot
// module id = 254
// module chunks = 0